module.exports = __webpack_public_path__ + "baf9c33732217d57b46ab215302800a7.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-facebook.png
// module id = 631
// module chunks = 0